import { useState } from 'react';

const INVALID_CHARS = /[\/]/;

function validateReportName(name) {
  if (!name) return null;
  if (INVALID_CHARS.test(name)) return 'Report name cannot contain slashes (/).';
  if (name === '.' || name === '..') return 'Report name cannot be "." or "..".';
  return null;
}

function NewReportModal({ onClose, onCreate }) {
  const [name, setName] = useState('');
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setName(e.target.value);
    setError(validateReportName(e.target.value.trim()));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    const err = validateReportName(trimmed);
    if (err) { setError(err); return; }
    onCreate(trimmed);
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        zIndex: 1000,
        backdropFilter: "blur(4px)",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "20px 20px 0 0",
          padding: "24px 20px",
          width: "100%",
          maxWidth: 390,
          animation: "slideUp 0.3s ease-out",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: "#111" }}>
            New Expense Report
          </h2>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", fontSize: 24, cursor: "pointer", color: "#888", padding: 0, lineHeight: 1 }}
          >
            ×
          </button>
        </div>
        <p style={{ margin: "0 0 20px", fontSize: 13, color: "#6B7280" }}>
          This will clear your current expenses. Give the new report a name.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="e.g. April 2026 Travel"
            value={name}
            onChange={handleChange}
            autoFocus
            style={{
              width: "100%",
              padding: 12,
              borderRadius: 10,
              border: `1.5px solid ${error ? "#EF4444" : "#E5E7EB"}`,
              fontSize: 15,
              outline: "none",
              boxSizing: "border-box",
              fontFamily: "inherit",
              marginBottom: error ? 6 : 16,
            }}
          />
          {error && (
            <p style={{ margin: "0 0 12px", fontSize: 12, color: "#EF4444" }}>{error}</p>
          )}
          <div style={{ display: "flex", gap: 12 }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                flex: 1,
                padding: "14px",
                borderRadius: 12,
                border: "1.5px solid #E5E7EB",
                background: "#fff",
                fontSize: 14,
                fontWeight: 700,
                cursor: "pointer",
                color: "#6B7280",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!name.trim() || !!error}
              style={{
                flex: 2,
                padding: "14px",
                borderRadius: 12,
                border: "none",
                background: name.trim() && !error
                  ? "linear-gradient(135deg, #0A7C8A 0%, #05C4B0 100%)"
                  : "#E5E7EB",
                color: name.trim() && !error ? "#fff" : "#9CA3AF",
                fontSize: 14,
                fontWeight: 700,
                cursor: name.trim() && !error ? "pointer" : "not-allowed",
                boxShadow: name.trim() && !error ? "0 4px 15px rgba(5, 196, 176, 0.3)" : "none",
              }}
            >
              Create Report
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewReportModal;
